// 公共使用的混入函数
import { ROLE_OPERATE } from "../config/common.js";
import { mapGetters } from "vuex"; // 导入 mapGetters 辅助函数
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["role"]),
  },
  methods: {
    /**
     * 公共 - 校验用户权限
     * 一般是操作性质的动作之前会验证
     */
    checkUserRole(roleKey = ROLE_OPERATE) {
      const roleList = this.role || [];
      if (roleList.includes(roleKey)) {
        return true;
      } else {
        this.$toast.fail(this.$t("warning.noPermission"));
        return false;
      }
    },
  },
};
